import React from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from '@ff-os/shared-react/components/radio-group/Radio';
import classNames from 'classnames';
import styles from './ColorAttributeRadio.module.scss';

export const ColorAttributeRadio = ({ value, label, options, onClick, active }: Props) => {

    const { t } = useTranslation();

    const classes = classNames(styles.default, {
        [styles.active]: active
    });

    const previewStyle = options?.assetUrl
        ? { backgroundImage: `url(${options.assetUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : { backgroundColor: value };

    return (
        <Radio key={value} value={value} label={t(label)}
            className={classes} active={active}
            onClick={() => onClick(value)}>
            {t(label)}
            <div className={styles.preview} style={previewStyle} />
        </Radio>
    );
};

type Props = {
    label: string;
    value: string;
    options?: {
        assetUrl?: string;
    };
    onClick: (value: string) => void;
    active: boolean;
};